var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegracionCultura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187px",
    height: "187px",
    viewBox: "0 0 187 187",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 187,
    height: 187,
    rx: 22,
    fill: "#d8a568"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.5, 55) scale(0.12) translate(-512, -512)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    d: "M890.378 185.931v-87.011l-394.703 87.011h-33.281l-394.703-87.011v87.011h-41.486v695.564h431.986v0.957l4.205-0.957h33.281l4.205 0.957v-0.957h497.918v-695.564h-107.421zM109.383 185.931v-35.199l348.804 76.934v603.011l-348.804-76.973v-567.774zM848.722 150.654v602.969l-348.844 76.934v-602.969l348.844-76.934zM961.559 558.27h-48.986v-49.111h48.986v49.111zM88.513 831.553v-39.819l180.482 39.819h-180.482zM876.463 790.151v41.319h-187.354l187.354-41.319zM411.698 339.134l-258.582-86.096 5.747-17.164 7.497-22.368 258.582 86.096-13.247 39.529zM411.698 450.802l-258.582-86.096 13.164-39.529 258.582 86.096-13.164 39.529zM411.698 562.518l-258.582-86.096 13.164-39.529 258.582 86.096-13.164 39.529zM411.698 674.106l-258.582-86.055 13.164-39.529 258.582 86.055-13.164 39.529zM411.698 772.951l-258.582-86.055 13.164-39.529 258.582 86.055-13.164 39.529zM546.405 339.134l-13.164-39.529 258.54-86.096 7.497 22.368 5.79 17.164-258.666 86.096zM546.405 450.802l-13.164-39.529 258.54-86.096 13.164 39.529-258.54 86.096zM546.405 562.518l-13.164-39.529 258.54-86.096 13.164 39.529-258.54 86.096zM546.405 674.106l-13.164-39.529 258.54-86.055 13.164 39.529-258.54 86.055zM546.405 772.951l-13.164-39.529 258.54-86.055 13.164 39.529-258.54 86.055z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93.5,
    y: 122
  }, "Integraci\xF3n"), /*#__PURE__*/React.createElement("tspan", {
    x: 93.5,
    dy: 20
  }, "a la cultura"), /*#__PURE__*/React.createElement("tspan", {
    x: 93.5,
    dy: 20
  }, "universitaria"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegracionCultura);
export default __webpack_public_path__ + "static/media/Integracion_cultura.6fb8614e428a59d12718cf5a4675fcb5.svg";
export { ForwardRef as ReactComponent };